import type { Cell } from '../types';

// Scoring functions

export const countYugos = (board: (Cell | null)[][], playerColor: 'white' | 'black'): number => {
  let count = 0;
  for (let row = 0; row < 8; row++) {
    for (let col = 0; col < 8; col++) {
      const cell = board[row][col];
      if (cell && cell.isYugo && cell.color === playerColor) {
        count++;
      }
    }
  }
  return count;
};

